import { render } from "./editWishlist.vue?vue&type=template&id=036f579c"
import script from "./editWishlist.vue?vue&type=script&lang=js"
export * from "./editWishlist.vue?vue&type=script&lang=js"

import "./editWishlist.vue?vue&type=style&index=0&id=036f579c&lang=scss"

import exportComponent from "/home/lexmodo/projects/wishlist_remote/wishlist_admin/wishlist-frontend-to-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__